export {
  compareByName,
  compareByKey,
  isauthorized,
  insertByComparison,
  validateEmail,
  localStorageSetKeyOrRemove,
  copyToClipboard,
  uuidv4,
  getTimeAsMinutes,
}

export const GUILD_ADMIN = 100;
export const DESTINATIONS_MANAGER = 90;
export const PROPERTIES_MANAGER = 85;
export const LOCKOUTS_MANAGER = 80;
export const LOCKOUT_CONTROLLER = 70;
export const ATTENDANCE_OVERVIEW = 20;
export const ASSIGN_PROPERTIES = 15;
export const BASIC_PLANNING = 10;

function isauthorized( user, guild, access ) {
  return user.admin
      || ( user.guilds && user.guilds[ guild['.key'] ] >= access );
}

function compareByName( a, b ) {
  const aUP = a.name.toUpperCase()
  const bUP = b.name.toUpperCase()
  if ( aUP < bUP ) {
    return -1;
  }
  if ( aUP > bUP ) {
    return 1;
  }
  return 0;
}

function compareByKey( a, b ) {
  if ( a['.key'] < b['.key'] ) {
    return -1;
  }
  if ( a['.key'] > b['.key'] ) {
    return 1;
  }
  return 0;
}

function validateEmail( email ) 
{
  let re = /\S+@\S+\.\S+/;
  return re.test( email );
}

function localStorageSetKeyOrRemove( item, object ) {
  if( object ) {
    localStorage.setItem( item, object['.key'] )
  }
  else {
    localStorage.removeItem( item )
  }
}

function copyToClipboard( document, string ) {
  const el = document.createElement('textarea');
  el.value = string;
  el.setAttribute('readonly', '');
  el.style.position = 'absolute';
  el.style.left = '-9999px';
  document.body.appendChild(el);
  const selected =  document.getSelection().rangeCount > 0  ? document.getSelection().getRangeAt(0) : false;
  el.select();
  document.execCommand( 'copy' );
  document.body.removeChild(el);
  if( selected ) {
    document.getSelection().removeAllRanges();
    document.getSelection().addRange( selected );
  }
}

function uuidv4() {
  // This is not supported on Live env
  // return crypto.randomUUID();

  return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
    (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
  );
}

function getTimeAsMinutes( timestr ) {
  if( !timestr ) return 0

  let hoursandminutes = timestr.split( ':' )
  if( hoursandminutes.length != 2 ) return 0

  let hours = parseInt( hoursandminutes[0] )
  let mins = parseInt( hoursandminutes[1] )
  if( isNaN( hours ) || isNaN( mins ) ) return 0

  return hours * 60 + mins
}

function insertByComparison( array, item, compare )
{
  let index = array.findIndex( item2 => compare( item, item2 ) <= 0 )
  if( index >= 0 ) array.splice( index, 0, item )
  else array.push( item )
}

